// src/modules/transactionRolling/reducer.ts
import { ActionType, getType } from 'typesafe-actions';
import * as actions from './actions';
import { TransactionRollingState, AsyncState } from './types';

type TRAction = ActionType<typeof actions>;

const asyncInit = <T>(data: T): AsyncState<T> => ({
  data,
  loading: false,
  error: null,
});

const initialState: TransactionRollingState = {
  generate: asyncInit<null>(null),
  valueDates: asyncInit<null>(null),
  listActiveRolls: asyncInit<null>(null),
  deleteRolls: asyncInit<null>(null),
  submitRolls: asyncInit<null>(null),
  groupingRules: asyncInit<null>(null),
};

export const transactionRollingReducer = (
  state: TransactionRollingState = initialState,
  action: TRAction,
): TransactionRollingState => {
  switch (action.type) {
    // === Generate Rolls ===
    case getType(actions.generateFxRolls.request):
      return {
        ...state,
        generate: { ...state.generate, loading: true, error: null },
      };
    case getType(actions.generateFxRolls.success):
      return {
        ...state,
        generate: { data: action.payload.data, loading: false, error: null },
      };
    case getType(actions.generateFxRolls.failure):
      return {
        ...state,
        generate: { ...state.generate, loading: false, error: action.payload.error },
      };

    // === Value Dates ===
    case getType(actions.fetchFxRollValueDates.request):
      return {
        ...state,
        valueDates: { ...state.valueDates, loading: true, error: null },
      };
    case getType(actions.fetchFxRollValueDates.success):
      return {
        ...state,
        valueDates: { data: action.payload.data, loading: false, error: null },
      };
    case getType(actions.fetchFxRollValueDates.failure):
      return {
        ...state,
        valueDates: { ...state.valueDates, loading: false, error: action.payload.error },
      };

    // === List Active Rolls ===
    case getType(actions.listFxRolls.request):
      return {
        ...state,
        listActiveRolls: { ...state.listActiveRolls, loading: true, error: null },
      };
    case getType(actions.listFxRolls.success):
      return {
        ...state,
        listActiveRolls: { data: action.payload.data, loading: false, error: null },
      };
    case getType(actions.listFxRolls.failure):
      return {
        ...state,
        listActiveRolls: { ...state.listActiveRolls, loading: false, error: action.payload.error },
      };

    // === Delete Rolls ===
    case getType(actions.deleteFxRolls.request):
      return {
        ...state,
        deleteRolls: { ...state.deleteRolls, loading: true, error: null },
      };
    case getType(actions.deleteFxRolls.success):
      return {
        ...state,
        deleteRolls: { data: action.payload.data, loading: false, error: null },
      };
    case getType(actions.deleteFxRolls.failure):
      return {
        ...state,
        deleteRolls: { ...state.deleteRolls, loading: false, error: action.payload.error },
      };

    // === Submit Rolls ===
    case getType(actions.submitFxRolls.request):
      return {
        ...state,
        submitRolls: { ...state.submitRolls, loading: true, error: null },
      };
    case getType(actions.submitFxRolls.success):
      return {
        ...state,
        submitRolls: { data: action.payload.data, loading: false, error: null },
      };
    case getType(actions.submitFxRolls.failure):
      return {
        ...state,
        submitRolls: { ...state.submitRolls, loading: false, error: action.payload.error },
      };

    case getType(actions.resetGenerateFxRolls):
      return { ...state, generate: asyncInit<null>(null) };
    case getType(actions.resetFxRollValueDates):
      return { ...state, valueDates: asyncInit<null>(null) };
    case getType(actions.resetListFxRolls):
      return { ...state, listActiveRolls: asyncInit<null>(null) };
    case getType(actions.resetDeleteFxRolls):
      return { ...state, deleteRolls: asyncInit<null>(null) };
    case getType(actions.resetSubmitFxRolls):
      return { ...state, submitRolls: asyncInit<null>(null) };

    // === Grouping Rules ===
    case getType(actions.fetchGroupingRules.request):
      return {
        ...state,
        groupingRules: { ...state.groupingRules, loading: true, error: null },
      };
    case getType(actions.fetchGroupingRules.success):
      return {
        ...state,
        groupingRules: { data: action.payload.data, loading: false, error: null },
      };
    case getType(actions.fetchGroupingRules.failure):
      return {
        ...state,
        groupingRules: { ...state.groupingRules, loading: false, error: action.payload.error },
      };
    case getType(actions.resetGroupingRules):
      return { ...state, groupingRules: asyncInit<null>(null) };

    default:
      return state;
  }
};
